// 吃瓜17社区 演示用 mock 数据（仅作静态展示占位，接入后端后可替换）
export const boards = [
  { key: "hot", name: "热门瓜料", icon: "ri-fire-fill", color: "text-primary-500 bg-primary-100", posts: 1280 },
  { key: "ent", name: "娱乐八卦", icon: "ri-star-smile-fill", color: "text-accent-700 bg-accent-100", posts: 954 },
  { key: "tech", name: "科技热评", icon: "ri-cpu-line", color: "text-foreground-700 bg-foreground-100", posts: 721 },
  { key: "life", name: "生活段子", icon: "ri-cup-line", color: "text-secondary-700 bg-secondary-100", posts: 863 },
  { key: "sport", name: "体育赛场", icon: "ri-basketball-line", color: "text-primary-600 bg-primary-100", posts: 412 },
  { key: "game", name: "游戏吃瓜", icon: "ri-gamepad-line", color: "text-accent-600 bg-accent-100", posts: 635 },
  { key: "soc", name: "社会观察", icon: "ri-earth-line", color: "text-foreground-600 bg-foreground-100", posts: 508 },
  { key: "chat", name: "广场闲聊", icon: "ri-chat-3-line", color: "text-secondary-600 bg-secondary-100", posts: 1677 },
];

export const feedPosts = [
  {
    id: 1,
    pinned: true,
    board: "热门瓜料",
    title: "一周热搜盘点：这届网友都在吵什么？",
    desc: "本周站内讨论度最高的五个话题集中复盘，从翻车现场到神仙操作，一条条帮你梳理时间线，看完不再漏瓜。",
    topics: ["#热搜复盘", "#本周话题"],
    time: "8 分钟前",
    views: 32800,
    replies: 1216,
    likes: 894,
    author: "吃瓜观察员",
    avatarChar: "观",
    tone: "bg-primary-500",
  },
  {
    id: 2,
    board: "娱乐八卦",
    title: "剧集收官后，主演们评论区都炸了",
    desc: "大结局播出当晚的评论区堪称名场面，有人真情实感磕到结尾，也有人直接开启二创狂欢，来看看网友都在聊什么。",
    topics: ["#追剧日常", "#剧评"],
    time: "26 分钟前",
    views: 21900,
    replies: 746,
    likes: 523,
    author: "凌晨三点还醒着",
    avatarChar: "醒",
    tone: "bg-accent-500",
  },
  {
    id: 3,
    board: "科技热评",
    title: "新旗舰发布，首发评测到底值不值得冲？",
    desc: "性能、影像、续航逐项拆解，热评区吵成一锅粥，理性党与冲动党的对峙现场，附网友的真实使用反馈。",
    topics: ["#数码圈", "#首发评测"],
    time: "41 分钟前",
    views: 18600,
    replies: 645,
    likes: 471,
    author: "参数不背锅",
    avatarChar: "参",
    tone: "bg-secondary-500",
  },
  {
    id: 4,
    board: "生活段子",
    title: "论当代打工人的下班仪式感，笑不活了",
    desc: "有人说下班是一条分界线，也有人表示猫粮才是终点。评论区集齐各种花式下班姿势，你属于哪一种？",
    topics: ["#打工人", "#段子手"],
    time: "1 小时前",
    views: 30500,
    replies: 982,
    likes: 1203,
    author: "打工人本工",
    avatarChar: "打",
    tone: "bg-primary-400",
  },
  {
    id: 5,
    board: "体育赛场",
    title: "关键一球绝杀，赛后教练采访金句频出",
    desc: "最后一节的剧本谁也没猜到，绝杀瞬间弹幕直接起飞。赛后采访更是一波三折，网友已经开始整活表情包。",
    time: "1 小时前",
    views: 15200,
    replies: 428,
    likes: 356,
    author: "深夜看球的老王",
    avatarChar: "王",
    tone: "bg-accent-600",
  },
  {
    id: 6,
    board: "游戏吃瓜",
    title: "新赛季改动爆料，玩家社区两极分化",
    desc: "平衡性改动刚放出就吵翻天，老玩家直呼爷青回，新玩家表示看不懂，来看看各路大神的理性分析。",
    time: "2 小时前",
    views: 13800,
    replies: 517,
    likes: 302,
    author: "峡谷老六",
    avatarChar: "六",
    tone: "bg-foreground-500",
  },
  {
    id: 7,
    board: "社会观察",
    title: "关于「情绪价值」这件事，你怎么看？",
    desc: "从朋友聊天到职场关系，情绪价值成为今年高频词。帖子引发深水区讨论，理性与感性在此交锋。",
    time: "3 小时前",
    views: 24600,
    replies: 867,
    likes: 690,
    author: "深夜写稿人",
    avatarChar: "稿",
    tone: "bg-secondary-600",
  },
];

export const topList = [
  { rank: 1, title: "剧集收官后主演评论区都炸了", heat: "3280 讨论" },
  { rank: 2, title: "新旗舰首发评测到底值不值", heat: "2146 讨论" },
  { rank: 3, title: "论当代打工人下班仪式感", heat: "1983 讨论" },
  { rank: 4, title: "情绪价值被过度消费了吗", heat: "1502 讨论" },
  { rank: 5, title: "新赛季改动为何两极分化", heat: "1330 讨论" },
  { rank: 6, title: "关键绝杀背后的一夜成名", heat: "1108 讨论" },
  { rank: 7, title: "谁的暑假片单在朋友圈刷屏", heat: "984 讨论" },
  { rank: 8, title: "那家被全网围观的店后来怎样", heat: "871 讨论" },
];

export const hotUsers = [
  { name: "前排吃瓜", char: "前", tone: "bg-primary-500", fans: "2.1w", intro: "今日 12 帖" },
  { name: "真相挖掘机", char: "掘", tone: "bg-accent-500", fans: "1.8w", intro: "专注复盘" },
  { name: "彩虹弹幕机", char: "彩", tone: "bg-secondary-500", fans: "1.5w", intro: "评论机器" },
  { name: "熬夜冠军", char: "冠", tone: "bg-foreground-500", fans: "1.2w", intro: "凌晨在线" },
  { name: "理性小李", char: "理", tone: "bg-primary-400", fans: "9600", intro: "就事论事" },
];

export const featured = [
  {
    key: "f1",
    board: "群聊精华",
    tag: "讨论炸裂",
    title: "深夜群聊：我们聊聊被误解的勇气",
    summary: "一场从 22 点开到凌晨的群聊，几百条消息里藏着不少金句，编辑部把最有共鸣的发言整理成了精华。",
    replies: 892,
    views: 23100,
    image: "https://readdy.ai/api/search-image?query=warm%20cream%20background%20with%20soft%20orange%20chat%20bubbles%20and%20grain%20texture%2C%20playful%20community%20conversation%20illustration%2C%20minimal%20modern%20editorial%20art%2C%20cozy%20evening%20mood%2C%20no%20text&width=900&height=640&seq=f-chat-1&orientation=landscape",
  },
  {
    key: "f2",
    board: "板块专题",
    tag: "编辑部精选",
    title: "一份给新瓜友的社区生存指南",
    summary: "从选板块、找同好到看懂站内黑话，新手最常踩的坑一次讲清楚，让你第一天就玩得明白又开心。",
    replies: 416,
    views: 16800,
    image: "https://readdy.ai/api/search-image?query=soft%20mint%20green%20and%20cream%20flat%20illustration%20of%20guide%20book%2C%20map%20and%20compass%2C%20community%20onboarding%20theme%2C%20minimal%20editorial%20design%2C%20clean%20background%2C%20no%20text&width=900&height=640&seq=f-guide-2&orientation=landscape",
  },
  {
    key: "f3",
    board: "圆桌话题",
    tag: "本周圆桌",
    title: "当网络热梗开始改变我们的聊天方式",
    summary: "流行语到底是在拉近距离还是在制造门槛？不同年龄层的网友各执一词，观点交锋非常精彩。",
    replies: 658,
    views: 19400,
    image: "https://readdy.ai/api/search-image?query=warm%20coral%20and%20sand%20tones%20abstract%20round%20table%20discussion%20illustration%2C%20speech%20bubbles%20floating%2C%20modern%20minimal%20editorial%20vector%20style%2C%20clean%20background%2C%20no%20text&width=900&height=640&seq=f-round-3&orientation=landscape",
  },
];

export const chatHighlights = [
  { who: "前排吃瓜", tone: "bg-primary-500", text: "这波我愿称之为本季最强名场面，弹幕已经笑到打鸣。" },
  { who: "真相挖掘机", tone: "bg-accent-500", text: "别急着站队，我翻了下原帖，发现事情还有个被忽略的角度……" },
  { who: "彩虹弹幕机", tone: "bg-secondary-500", text: "谁懂啊，评论区人均文豪，金句一条接一条根本停不下来。" },
  { who: "熬夜冠军", tone: "bg-foreground-500", text: "凌晨一点还在爬楼，这帖子后劲是真的大，看完睡不着了。" },
];

export const faqs = [
  {
    q: "吃瓜17社区是什么？",
    a: "吃瓜17社区是一个面向中文用户的论坛讨论平台，围绕娱乐、科技、社会、生活等热门话题组织讨论，聚合网友发布的帖子、评论与群聊精华，让每个人都能找到感兴趣的话题并参与其中。",
  },
  {
    q: "如何加入吃瓜17社区并参与讨论？",
    a: "注册吃瓜17账号后即可浏览全站帖子，在任意话题下发帖、评论、点赞与收藏，还可以加入不同兴趣板块的群聊，与其他瓜友实时交流看法。注册只需一个邮箱或手机号，几分钟即可完成。",
  },
  {
    q: "在吃瓜17发帖有哪些规则？",
    a: "请遵守社区公约：文明发言、就事论事、不信谣不传谣，避免人身攻击与隐私泄露。发布内容请选择合适板块并如实标记话题，违规范帖经审核确认后会被移除或折叠。",
  },
  {
    q: "帖子热度是怎么计算的？",
    a: "热度综合帖子近期的浏览量、评论数、点赞与收藏计算，实时滚动更新。热榜每几分钟刷新一次，让你第一时间看到正在被广泛讨论的内容。",
  },
  {
    q: "群聊精华和普通帖子有什么区别？",
    a: "群聊精华由编辑部从站内实时群聊中挑选出最有价值的发言整理而成，相当于把刷屏信息浓缩成一条便于阅读和回顾的帖子，适合没时间爬楼的新瓜友。",
  },
];

export const testimonials = [
  {
    name: "阿橙",
    char: "橙",
    tone: "bg-primary-500",
    role: "潜水两年老瓜友",
    text: "这里节奏刚刚好，既有深度讨论也有轻松段子，板块分得清楚，想找同好特别容易。",
  },
  {
    name: "小林同学",
    char: "林",
    tone: "bg-accent-500",
    role: "新晋发帖选手",
    text: "第一次发帖就有人认真回复，评论区氛围很友好，编辑部的群聊精华整理得也很用心。",
  },
  {
    name: "陆大爷",
    char: "陆",
    tone: "bg-secondary-500",
    role: "深夜常驻观众",
    text: "追热门话题追了好几年，这边信息更新快、讨论理性，是我每天睡前的固定去处。",
  },
];

export const stats = [
  { value: "8.6w+", label: "注册瓜友" },
  { value: "1.2w+", label: "本周新增帖子" },
  { value: "320w+", label: "累计浏览量" },
  { value: "28 个", label: "兴趣板块" },
];